import { InfoGridFuelCategory } from '@ahd/shared/types/ahd-fleet-api/fleet-car/enums';
import { FdTypes } from '@ahd/shared/types/ahd-fleet-api/fleet-car/fd/types';

import { Modules } from '../modules/_definition/types';
import { type Translations } from './translations';

const frFR: Translations = {
    buttons: {
        acceptMaps: "Cliquez ici pour accepter l'utilisation de Google Maps!",
        advancedSearch: 'Recherche avancée',
        back: 'Retour',
        backToSearch: 'Retour à la recherche',
        chooseVehicleHeading: 'Choisir un véhicule',
        clear: 'Vider',
        close: 'Fermer',
        collapse: 'Fermer',
        continue: 'Continuer',
        expand: 'Déplier',
        filters: 'Filtres',
        loadingView: 'Chargement de la vue...',
        loadMoreResults: "Chargement d'autres résultats",
        loadMoreVehicles: "Chargement d'autres véhicules...",
        loadMoreVehiclesVariant: 'Afficher plus de véhicules',
        nextPage: 'Suivant',
        no: 'Non',
        prevPage: 'Page précédente',
        rateCalculator: 'Calculateur de mensualités',
        resetData: 'Réinitialiser les données',
        resetFilter: 'Réinitialiser le filtre',
        search: 'Recherche',
        showAllLocations: 'Afficher tous les emplacements',
        showAllVehicles: 'Afficher tous les {0} véhicules',
        skip: 'Sauter',
        vehicle: 'Véhicule',
        vehicles: 'Véhicules',
        yes: 'Oui',
    },
    car: {
        ez: 'Première immatriculation',
        km: 'Kilométrage',
        ident: 'Numéro de commande à Référence',
        kategorie: 'Catégorie',
        leergewicht: 'Poids à vide',
        typ: 'Type de véhicule',
        types: {
            singular: {
                '-': '(inconnu)',
                '1': 'Véhicule neuf',
                '2': "Véhicule d'occasion",
                '4': 'Véhicule de démonstration',
                '8': 'Véhicule de location',
                '16': 'Véhicule spécial',
                '32': 'Véhicule immatriculé pour la journée',
            },
            plural: {
                '-': '(inconnu)',
                '1': 'Véhicules neufs',
                '2': "Véhicules d'occasion",
                '4': 'Véhicules de démonstration',
                '8': 'Véhicules de location',
                '16': 'Véhicules spéciaux',
                '32': 'immatriculations journalières',
            },
        },
        sitze: 'Sièges',
        tueren: 'Portes',
        engine: {
            effizienz: 'Efficacité',
            hubraum: 'Cylindrée',
            leistung: 'Puissance',
            motor: 'Moteur',
            verbrauch: {
                '0': 'Consommation combinée',
                '1': 'Émissions de CO₂',
                '2ndDrive': '2ème propulsion',
                combined: 'Combiné',
                effizienz: 'Efficacité',
                schadstoff: 'Norme Euro',
                heading: 'Consommation et émissions',
                inner: 'En ville',
                outer: 'Hors agglomération',
                slow: 'Centre-ville',
                medium: 'Périphérie',
                fast: 'Route',
                veryFast: 'Autoroute',
                range: 'Portée',
                city: 'Ville',
                protocol: 'Consommation',
                protocolBy: 'Consommation après {0}',
                nefz: 'NEDC',
                wltp: 'WLTP',
                noNEFZAvailable: 'Aucune valeur NEDC disponible',
            },
        },
        garantie: 'Garantie',
        getriebe: 'Boîte de vitesses',
        siegel: 'Sceau',
        standort: 'Emplacement',
        farbe: 'Couleur',
        antrieb: 'Transmission',
        verfuegbarkeit: 'Disponibilité',
        verfuegbarAb: 'Disponible à partir de',
        aktion: "Véhicule d'action",
        nowAvailable: 'disponible immédiatement',
        lieferzeit: 'Délai de livraison',
        isOrderCar: 'Véhicule de commande',
        onlyCommercial: 'Uniquement commercial',
        preis: {
            inclMwst: 'TVA {0} incluse',
            exclMwst: 'TVA non affichable',
        },
        aus: {
            categories: {
                kopf: '',
                highlights: 'Highlights',
                technik: 'Technique et sécurité',
                multimedia: 'Multimédia',
                assistenz: "Systèmes d'assistance",
                innen: 'Equipement intérieur',
                sitze: 'Sièges et garnitures',
                aussen: 'Equipement extérieur',
                scheinwerfer: 'Phares et feux',
                raeder: 'Roues et pneus',
                pakete: 'Paquets',
                sonstiges: 'Autres',
                fussnoten: 'Notes de bas de page',
                fuss: '',
            },
            assistenz: {
                title: "Systèmes d'assistance",
                25: 'Régulateur de vitesse (GRA)',
                26: 'Aide au stationnement (APS)',
                48: 'Assistant de stationnement',
                332: 'Régulateur de distance',
                402: 'Caméra de recul',
                514: 'Assistant de changement de voie',
                515: 'Assistant de maintien de voie',
                1145: 'Reconnaissance des panneaux de signalisation',
            },
            aussen: {
                title: 'Equipement extérieur',
                34: 'Toit ouvrant',
                41: 'Phares au xénon',
                71: 'Jantes en alliage léger',
                88: 'Attelage de remorque',
                238: 'Toit panoramique / vitré',
                1140: 'Phares à LED',
            },
            innen: {
                title: 'Equipement intérieur',
                22: 'Climatisation automatique',
                23: 'Chauffage auxiliaire',
                24: 'Système de navigation',
                27: 'lève-vitres électriques',
                29: 'Sièges chauffants',
                36: 'Sièges électriques',
                81: 'Equipement en cuir',
                278: 'Sièges sport',
                1119: 'Bluetooth',
            },
            showMore: {
                btn: 'Afficher tous les équipements',
                subtitle: 'Il y a encore plus à découvrir!',
            },
            sonstiges: {
                title: 'Autres',
                61: 'Quatre roues motrices',
            },
        },
    },
    carSearch: {
        foundCar: 'Véhicule trouvé',
        foundCars: 'Véhicules trouvé',
        forFilters: 'pour filtre',
        grid: 'Carreaux',
        heading: "Véhicules neufs et d'occasion",
        heading2: "Véhicules d'occasion",
        list: 'Liste',
        page: 'Page',
        sort: 'Tri',
        view: 'Vue',
    },
    carTile: {
        priceGrid: {
            diff25a: '§ 25a (UStG)',
            diff25aDesc: 'Taxe supplémentaire non identifiable',
        },
        verbrauchText: {
            combined: 'comb.',
            discharged: 'déchargée',
            weighted: 'pond.',
        },
    },
    carView: {
        accessoires: {
            contactPlusAccessoiresPrice: '(+ Accessoires)',
            special: 'Équipement de spécial',
            standard: 'Équipement de série',
            title: 'Vous trouverez ici des accessoires pour votre {0} {1}',
            titleSelected: 'Vos accessoires sélectionnés',
            withAccessoiresPrice: 'plus {0} € pour les accessoires',
        },
        contactTab: {
            approach: "Plan d'accès",
            call: 'Appeler',
            mail: 'Mail',
            message: 'Demande',
            phone: 'Téléphone',
        },
        contact: {
            abort: 'Annuler',
            bdkAddInsurances: 'Assurance complémentaire',
            bdkCreditCheck: 'Vérification préliminaire de la solvabilité',
            bdkSubmit: 'Envoyer la demande',
            bdkVendorContact: 'Demande aux revendeurs',
            title: 'Contact',
            contactPerson: 'Votre contact',
            copyTel: {
                error: 'Erreur',
                success: 'Copié',
            },
            fd: 'Votre service financier',
            requestType: 'Type de demande',
            requestTypes: {
                '0': 'Envoyer un demande',
                '0a': 'Envoyer un demande à',
                '0b': 'Demande de financement',
                '0c': 'Demande de leasing',
                '10': 'Demander un rendez-vous',
                '10a': 'Demander un rendez-vous chez',
                '12': 'Demander un rappel',
                '12a': 'Demander un rappel par',
                '20': "Demande d'essai",
                '20a': "Demande d'essai chez",
                '27': 'Prise de paiement',
                '27a': 'Prise de paiement chez',
                '0Short': 'demande',
                '10Short': 'Rendez-vous',
                '12Short': 'Rappel',
                '20Short': 'Essai de conduite',
                '27Short': 'Prise de paiement',
            },
            name: 'Nom',
            mail: 'Mail',
            priceAlert: 'Alerte prix',
            priceAlertInfo: 'Recevez un e-mail si le prix de ce véhicule tombe en dessous de votre prix souhaité',
            phone: 'Téléphone',
            testDriveWithContactRequest: 'Essai souhaité',
            date: 'Date souhaitée',
            dateWithContactRequest: "Date souhaitée pour l'essai",
            message: 'Votre demande',
            disclaimer: "J'ai lu le {0}",
            disclaimerLink: 'Politique de confidentialité',
            reset: 'Reprendre au début',
            requestSuccess: 'La demande a été acceptée',
            send: 'Envoyer un demande',
            sending: 'Envoyer...',
            errorSending: "Erreur lors de l'envoi du demande",
            errorSkipStep: 'Cette étape ne peut pas être sautée',
            successSending: 'Demande envoyé avec succès',
            tryAgain: 'Veuillez réessayer dans quelques minutes',
            subjectPrefix: 'Demande de véhicule pour le véhicule {0}',
            subjectPrefixAbo: 'Demande de AutoAbo pour le véhicule {0}',
            errors: {
                reCaptcha: 'Echec de la vérification ReCAPTCHA',
                requestType: 'Type de demande manquant',
                name: 'Nom manquant',
                mailMissing: 'Mail manquant',
                mailInvalid: 'Mail dans un format incorrect',
                phone: 'Numéro de téléphone manquant',
                date: 'Date souhaitée manquante',
                message: 'Votre demande est manquant',
                acceptDisclaimer: 'Veuillez accepter la politique de confidentialité',
            },
        },
        newTabs: {
            0: {
                title: 'Accessoires',
                url: 'accessoires',
            },
            1: {
                title: 'Description',
                url: 'description',
            },
            2: {
                title: 'Consommation indiquée',
                url: 'consommation-indiquee',
            },
            3: {
                title: 'Emplacement',
                url: 'emplacement',
            },
        },
        calculator: {
            bonitat: 'Sous réserve de solvabilité',
            businessFinancingRequest: 'demande commerciale',
            button: 'Demandez maintenant pour {0} / mois',
            buttonBDK: 'Demandez maintenant directement au BDK pour {0} / mois',
            buttonVendor: 'Demandez maintenant directement au revendeur pour {0} / mois',
            creditCheck: {
                companyAge: "Âge de l'entreprise (en années)",
                insolvency: "J'ai fait l'objet d'une procédure d'insolvabilité ou d'une libération des dettes résiduelles:",
                isBusinessOwner: "J'ai enregistré un commerce:",
                isBusinessVehicle: 'Je souhaite également utiliser le véhicule à des fins commerciales:',
                monthlyExpenses: 'Total des dépenses mensuelles:',
                monthlyIncome: 'Revenu mensuel net total:',
                negativeSchufa: "J'ai un crédit négatif et je fais des paiements à des sociétés de recouvrement:",
                peopleInHousehold: 'Personnes dans le ménage:',
                title: "Évaluation préalable à l'octroi de crédit",
                titleInfo: '(facultatif)',
            },
            fd: {
                [FdTypes.ABO]: {
                    available: 'Disponible',
                    bank: 'Partenaire mobilité',
                    damageParticipation: 'Franchise',
                    deliveryOption: 'Options de livraison',
                    deliveryOption_faaren_delivery: 'Livraison par Faaren',
                    deliveryOption_no_delivery: 'Pas de livraison',
                    deliveryOption_partner_delivery: 'Livraison par le fournisseur',
                    deliveryTime: 'Délai de livraison après la commande',
                    detail0: 'Tout compris, sauf le carburant',
                    detail1: 'Résiliation mensuelle possible à la fin de la durée minimale',
                    downPayment: 'Acompte',
                    duration: 'Durée',
                    extraMileageCosts: 'Plusdekilomètres',
                    fixedDuration: 'Changeable tous les mois',
                    immediatelyAvailable: 'Disponible immédiatement',
                    mileage: 'Kilométrage mensuel',
                    minimumAge: 'Âge minimum',
                    minLicenseDuration: 'Durée minimale de détention du permis de conduire',
                    monthlyRateGross: 'Taux mensuel brut',
                    monthlyRateNet: 'Taux mensuel net',
                    pickUpOption: "Options d'enlèvement",
                    pickUpOption_faaren_delivery: 'Enlèvement par Faaren',
                    pickUpOption_no_delivery: "Pas d'enlèvement",
                    pickUpOption_partner_delivery: 'Enlèvement par le fournisseur',
                    provider: 'Provider',
                    title: 'Auto-Abo',
                    totalGross: 'Montant total brut',
                    totalNet: 'Montant total net',
                    type: 'Type',
                    vehiclePrice: 'Prix neuf du véhicule',
                    verb: 'louer',
                },
                [FdTypes.BUSINESS_LEASING]: {
                    annualPercentageRate: "Taux d'intérêt annuel",
                    available: 'Disponible',
                    bank: 'Banque fournisseur',
                    destinationChargesGross: 'Frais de mise à disposition brut',
                    destinationChargesNet: 'Frais de mise à disposition net',
                    detail0: 'Mensualité fixe',
                    detail1: 'Restitution du véhicule à la fin du contrat',
                    downPayment: 'Paiement spécial',
                    duration: 'Durée',
                    extraMileageCosts: 'Plusdekilomètres',
                    gapInsurance: "La Protection Garantie d'écart (GAP)",
                    gapInsuranceAmount: "Montant protection Garantie d'écart (GAP)",
                    lowMileageCompensation: 'Kilomètres en moins',
                    mileage: 'Kilométrage annuel',
                    monthlyRateGross: 'Taux mensuel brut',
                    monthlyRateNet: 'Taux mensuel net',
                    nominalInterestRate: "Taux d'intérêt débiteur",
                    provider: 'Provider',
                    registrationFeesGross: "Frais d'inscription brut",
                    registrationFeesNet: "Frais d'inscription net",
                    shortTitle: 'entreprise',
                    title: "Leasing d'entreprise",
                    totalGross: 'Montant total brut',
                    totalNet: 'Montant total net',
                    type: 'Type',
                    vehiclePrice: 'Prix du véhicule',
                    verb: 'lease',
                },
                [FdTypes.FINANCING_AUTOCREDIT]: {
                    annualPercentageRate: "Taux d'intérêt annuel",
                    available: 'Disponible',
                    bank: 'Banque fournisseur',
                    closingCosts: 'Frais de clôture',
                    destinationChargesGross: 'Frais de mise à disposition brut',
                    destinationChargesNet: 'Frais de mise à disposition net',
                    detail0: 'Mensualité faible',
                    detail1: 'Mensualité finale avec plusieurs options de souscription',
                    downPayment: 'Acompte',
                    duration: 'Durée',
                    finalInstallment: 'Dernier versement',
                    gapInsurance_GAP: 'GAP',
                    gapInsurance_GAP_desc: 'Souscrivez une assurance GAP.',
                    gapInsurance_GAP_PLUS: 'GAP Plus',
                    gapInsurance_GAP_PLUS_desc: 'Souscrivez une assurance GAP Plus.',
                    gapInsurance_NONE: 'Non',
                    gapInsurance_NONE_desc: "Pas d'assurance supplémentaire souhaitée.",
                    gapInsurance: "La Protection Garantie d'écart (GAP)",
                    gapInsuranceAmount: "Montant protection Garantie d'écart (GAP)",
                    mileage: 'Kilométrage annuel',
                    monthlyRateGross: 'Taux mensuel brut',
                    monthlyRateNet: 'Taux mensuel net',
                    nominalInterestRate: "Taux d'intérêt débiteur",
                    paymentProtectionInsurance: 'Assurance protection crédit',
                    paymentProtectionInsuranceAmount: 'Montant assurance protection crédit',
                    paymentProtectionInsurance_NONE: 'Non',
                    paymentProtectionInsurance_RSV: 'APC',
                    paymentProtectionInsurance_RSVPLUS: 'APC Plus',
                    provider: 'Provider',
                    registrationFeesGross: "Frais d'inscription brut",
                    registrationFeesNet: "Frais d'inscription net",
                    title: 'Financement',
                    totalGross: 'Montant total brut',
                    totalNet: 'Montant total net',
                    typeOfNominalInterestRate: "Type de taux d'intérêt débiteur",
                    type: 'Type',
                    vehiclePrice: 'Prix du véhicule',
                    verb: 'financent',
                },
                [FdTypes.FINANCING_CLASSICCREDIT]: {
                    annualPercentageRate: "Taux d'intérêt annuel",
                    available: 'Disponible',
                    bank: 'Banque fournisseur',
                    closingCosts: 'Frais de clôture',
                    destinationChargesGross: 'Frais de mise à disposition brut',
                    destinationChargesNet: 'Frais de mise à disposition net',
                    detail0: 'Mensualité faible',
                    detail1: 'Mensualité finale avec plusieurs options de souscription',
                    downPayment: 'Acompte',
                    duration: 'Durée',
                    finalInstallment: 'Dernier versement',
                    gapInsurance_GAP: 'GAP',
                    gapInsurance_GAP_desc: 'Souscrivez une assurance GAP.',
                    gapInsurance_GAP_PLUS: 'GAP Plus',
                    gapInsurance_GAP_PLUS_desc: 'Souscrivez une assurance GAP Plus.',
                    gapInsurance_NONE: 'Non',
                    gapInsurance_NONE_desc: "Pas d'assurance supplémentaire souhaitée.",
                    gapInsurance: "La Protection Garantie d'écart (GAP)",
                    gapInsuranceAmount: "Montant protection Garantie d'écart (GAP)",
                    mileage: 'Kilométrage annuel',
                    monthlyRateGross: 'Taux mensuel brut',
                    monthlyRateNet: 'Taux mensuel net',
                    nominalInterestRate: "Taux d'intérêt débiteur",
                    paymentProtectionInsurance: 'Assurance protection crédit',
                    paymentProtectionInsuranceAmount: 'Montant assurance protection crédit',
                    paymentProtectionInsurance_NONE: 'Non',
                    paymentProtectionInsurance_RSV: 'APC',
                    paymentProtectionInsurance_RSVPLUS: 'APC Plus',
                    provider: 'Provider',
                    registrationFeesGross: "Frais d'inscription brut",
                    registrationFeesNet: "Frais d'inscription net",
                    title: 'Financement',
                    totalGross: 'Montant total brut',
                    totalNet: 'Montant total net',
                    typeOfNominalInterestRate: "Type de taux d'intérêt débiteur",
                    type: 'Type',
                    vehiclePrice: 'Prix du véhicule',
                    verb: 'financent',
                },
                [FdTypes.FINANCING_INDIVIDUAL]: {
                    annualPercentageRate: "Taux d'intérêt annuel",
                    available: 'Disponible',
                    bank: 'Banque fournisseur',
                    closingCosts: 'Frais de clôture',
                    destinationChargesGross: 'Frais de mise à disposition brut',
                    destinationChargesNet: 'Frais de mise à disposition net',
                    detail0: 'Mensualité faible',
                    detail1: 'Mensualité finale avec plusieurs options de souscription',
                    downPayment: 'Acompte',
                    duration: 'Durée',
                    finalInstallment: 'Dernier versement',
                    gapInsurance_GAP: 'GAP',
                    gapInsurance_GAP_desc: 'Souscrivez une assurance GAP.',
                    gapInsurance_GAP_PLUS: 'GAP Plus',
                    gapInsurance_GAP_PLUS_desc: 'Souscrivez une assurance GAP Plus.',
                    gapInsurance_NONE: 'Non',
                    gapInsurance_NONE_desc: "Pas d'assurance supplémentaire souhaitée.",
                    gapInsurance: "La Protection Garantie d'écart (GAP)",
                    gapInsuranceAmount: "Montant protection Garantie d'écart (GAP)",
                    mileage: 'Kilométrage annuel',
                    monthlyRateGross: 'Taux mensuel brut',
                    monthlyRateNet: 'Taux mensuel net',
                    nominalInterestRate: "Taux d'intérêt débiteur",
                    paymentProtectionInsurance: 'Assurance protection crédit',
                    paymentProtectionInsuranceAmount: 'Montant assurance protection crédit',
                    paymentProtectionInsurance_NONE: 'Non',
                    paymentProtectionInsurance_RSV: 'APC',
                    paymentProtectionInsurance_RSVPLUS: 'APC Plus',
                    provider: 'Provider',
                    registrationFeesGross: "Frais d'inscription brut",
                    registrationFeesNet: "Frais d'inscription net",
                    title: 'Financement',
                    totalGross: 'Montant total brut',
                    totalNet: 'Montant total net',
                    typeOfNominalInterestRate: "Type de taux d'intérêt débiteur",
                    type: 'Type',
                    vehiclePrice: 'Prix du véhicule',
                    verb: 'financent',
                },
                [FdTypes.FINANCING_VARIO]: {
                    annualPercentageRate: "Taux d'intérêt annuel",
                    available: 'Disponible',
                    bank: 'Banque fournisseur',
                    closingCosts: 'Frais de clôture',
                    destinationChargesGross: 'Frais de mise à disposition brut',
                    destinationChargesNet: 'Frais de mise à disposition net',
                    detail0: 'Mensualité faible',
                    detail1: 'Mensualité finale avec plusieurs options de souscription',
                    downPayment: 'Acompte',
                    duration: 'Durée',
                    finalInstallment: 'Dernier versement',
                    gapInsurance_GAP: 'GAP',
                    gapInsurance_GAP_desc: 'Souscrivez une assurance GAP.',
                    gapInsurance_GAP_PLUS: 'GAP Plus',
                    gapInsurance_GAP_PLUS_desc: 'Souscrivez une assurance GAP Plus.',
                    gapInsurance_NONE: 'Non',
                    gapInsurance_NONE_desc: "Pas d'assurance supplémentaire souhaitée.",
                    gapInsurance: "La Protection Garantie d'écart (GAP)",
                    gapInsuranceAmount: "Montant protection Garantie d'écart (GAP)",
                    mileage: 'Kilométrage annuel',
                    monthlyRateGross: 'Taux mensuel brut',
                    monthlyRateNet: 'Taux mensuel net',
                    nominalInterestRate: "Taux d'intérêt débiteur",
                    paymentProtectionInsurance: 'Assurance protection crédit',
                    paymentProtectionInsuranceAmount: 'Montant assurance protection crédit',
                    paymentProtectionInsurance_NONE: 'Non',
                    paymentProtectionInsurance_RSV: 'APC',
                    paymentProtectionInsurance_RSVPLUS: 'APC Plus',
                    provider: 'Provider',
                    registrationFeesGross: "Frais d'inscription brut",
                    registrationFeesNet: "Frais d'inscription net",
                    title: 'Financement',
                    totalGross: 'Montant total brut',
                    totalNet: 'Montant total net',
                    typeOfNominalInterestRate: "Type de taux d'intérêt débiteur",
                    type: 'Type',
                    vehiclePrice: 'Prix du véhicule',
                    verb: 'financent',
                },
                [FdTypes.PRIVATE_LEASING]: {
                    annualPercentageRate: "Taux d'intérêt annuel",
                    available: 'Disponible',
                    bank: 'Banque fournisseur',
                    destinationChargesGross: 'Frais de mise à disposition brut',
                    destinationChargesNet: 'Frais de mise à disposition net',
                    detail0: 'Mensualité fixe',
                    detail1: 'Restitution du véhicule à la fin du contrat',
                    downPayment: 'Paiement spécial',
                    duration: 'Durée',
                    extraMileageCosts: 'Plusdekilomètres',
                    gapInsurance: "La Protection Garantie d'écart (GAP)",
                    gapInsuranceAmount: "Montant protection Garantie d'écart (GAP)",
                    lowMileageCompensation: 'Kilomètres en moins',
                    mileage: 'Kilométrage annuel',
                    monthlyRateGross: 'Taux mensuel brut',
                    monthlyRateNet: 'Taux mensuel net',
                    nominalInterestRate: "Taux d'intérêt débiteur",
                    provider: 'Provider',
                    registrationFeesGross: "Frais d'inscription brut",
                    registrationFeesNet: "Frais d'inscription net",
                    shortTitle: 'privé',
                    title: 'Leasing privé',
                    totalGross: 'Montant total brut',
                    totalNet: 'Montant total net',
                    type: 'Type',
                    vehiclePrice: 'Prix du véhicule',
                    verb: 'lease',
                },
            },
            gapInsuranceStepperTitle: 'assurance supplémentaire',
            insuranceInfoText: "* Une assurance complémentaire, telle qu'une assurance protection crédit (APC){0}, peut être convenue avec le commerçant sur demande.",
            orderRequest: {
                orderBdkDescription: 'Adressez votre demande directement à la Bank Deutsches Kraftfahrzeuggewerbe (BDK).',
                orderBdkInfo: "(Uniquement possible pour les demandes de financement avec une pré-évaluation réussie pour l'octroi du crédit)",
                orderBdkNotAvailable: "Ce service n'est malheureusement pas disponible pour le moment.",
                orderVendorDescription: 'Adressez votre demande directement au distributeur.',
            },
            title: {
                block: 'Financement ou leasing simple et flexible',
                blockWithAbo: "Financement, leasing ou s'abonner simple et flexible",
                financing: 'Financement',
                leasing: 'Leasing',
                rateSettings: 'Tes paramètres de mensualités',
                summary: {
                    financing: 'Votre offre de financement',
                    leasing: 'Votre offre de leasing',
                    autoAbo: 'Votre offre de Auto-Abo offer',
                },
                typeChooser: 'Choisissez votre poison',
            },
        },
        downloadExposee: 'Télécharger',
        exposeeError: 'Une erreur est survenue lors de la génération!\nVeuillez réessayer plus tard',
        exposeeLoading: "Un instant s'il vous plaît, l'exposé est généré",
        exposeeReady: "L'exposé est maintenant disponible pour le téléchargement",
        locationUsers: 'Votre contact',
        locationUsersContact: 'Prendre contact',
        share: {
            copy: 'Copier le lien',
            mail: 'Mail',
            title: 'Partager',
        },
        showExposee: 'Exposé',
        similarCars: 'Véhicules similaires',
        tabs: {
            0: 'Données du véhicule',
            1: 'Description',
            2: 'Emplacement',
        },
        tradeIn: {
            heading: 'Prise de paiement?',
            content: 'Vous souhaitez reprendre votre véhicule actuel et obtenir rapidement une valeur marchande sans engagement?',
            button: 'Calculer maintenant',
        },
        verbrauch: {
            combined: 'Combiné',
            combinedWeighted: 'Combiné (pondéré)',
            combinedWeightedShort: 'Comb. pond.',
            co2class: 'Classe de CO₂',
            co2classWeighted: 'Classe de CO₂ (pondéré)',
            co2costs: 'Coûts CO₂ possibles sur les 10 prochaines années (à 15.000 km / an):',
            co2costsBaseLow: 'en supposant un prix moyen bas du CO₂ de {0}',
            co2costsBaseMedium: 'en supposant un prix moyen moyen du CO₂ de {0}',
            co2costsBaseHigh: 'en supposant un prix moyen élevé du CO₂ de {0}',
            co2costsLow: 'faible prix du CO₂',
            co2costsMedium: 'prix moyen du CO₂',
            co2costsHigh: 'prix élevé du CO₂',
            discharged: 'lorsque la batterie\nest déchargée',
            energycosts: 'Coûts énergétiques par an (à 15.000 km / an)',
            emission: 'Émissions',
            emissionWeighted: 'Émissions (pondéré)',
            emissionWeightedShort: 'Émiss. pond.',
            euronorm: 'Norme Euro',
            extraHigh: 'Autoroute',
            fuelCostsYear: {
                [InfoGridFuelCategory.BIFUEL]: 'Prix moyen annuel du carburant',
                [InfoGridFuelCategory.CELL]: "Prix moyen annuel de l'hydrogène",
                [InfoGridFuelCategory.DEFAULT]: 'Prix moyen annuel du carburant',
                [InfoGridFuelCategory.ELECTRO]: "Prix moyen annuel de l'électricité",
                [InfoGridFuelCategory.GAS]: 'Prix moyen annuel du carburant',
                [InfoGridFuelCategory.OTHERHYBRID]: 'Prix moyen annuel du carburant',
                [InfoGridFuelCategory.PLUGINHYBRID]: 'Prix moyen annuel du carburant',
            },
            fuelCostsYearState: 'Prix: {0} | Situation: {1}',
            header: 'Consommation de carburant',
            headerDischarged: 'Consommation de carburant lorsque la batterie est déchargée',
            headerElectro: 'Consommation électrique',
            headerPlugIn: 'Consommation électrique en mode purement électrique',
            high: 'Route',
            medium: 'Périphérie',
            motor: 'Motor',
            low: 'Centre-ville',
            range: 'Portée électrique',
            title: 'Consommation et émissions',
            weighted: 'pondéré',
        },
    },
    common: {
        and: 'et',
        at: 'auprès',
        atThe: 'au',
        brutto: 'brut',
        in: 'en',
        netto: 'net',
        notAvailable: 'non disponible',
    },
    filter: {
        special: "Véhicules d'action",
        aktion: "Véhicules d'action",
        specialActive: 'Véhicules en promotion uniquement',
        exteriorColor: 'Couleur',
        make: 'Constructeur',
        hersteller0: 'Constructeur',
        model: 'Modèle',
        modell0: 'Modèle',
        condition: 'Type de véhicule',
        akttypList: 'Type de véhicule',
        stime: 'Durée de stockage',
        location: 'Emplacement',
        seller: 'Emplacement',
        Standort: 'Emplacement',
        locationMap: {
            buttonText: 'Vue de la carte',
            dialog: {
                filterButton: 'Afficher {0} véhicules',
                filterAllButton: 'Afficher tous les véhicules',
                title: 'Filtrer les Emplacement',
                selectAll: 'Sélectionner tout',
            },
        },
        category: 'Carrosserie',
        aufbau: 'Carrosserie',
        aufbauten: 'Carrosseries',
        usedCarSeal: 'Sceau',
        hasSeal: 'Sceau',
        price: 'Prix',
        priceFrom: 'Prix de',
        priceTo: "Prix jusqu'à",
        rate: 'Mensualité',
        rateFrom: 'Mensualité de',
        rateTo: "Mensualité jusqu'à",
        firstRegistration: 'Première immatriculation',
        firstRegistrationFrom: 'Première immatriculation de',
        firstRegistrationTo: "Première immatriculation jusqu'à",
        mileage: 'Kilométrage',
        mileageFrom: 'Kilométrage de',
        mileageTo: "Kilométrage jusqu'à",
        power: 'Puissance immatriculation',
        powerFrom: 'Puissance immatriculation de',
        powerTo: "Puissance immatriculation jusqu'à",
        fuel: 'Moteur',
        motoren: 'Moteur',
        gearbox: 'Boîte de vitesses',
        available: 'Disponible immédiatement',
        sofort: 'Disponible immédiatement',
        availableActive: 'Seulement disponible immédiatement',
        tags: 'Action',
        tagsExclude: "Exclusion d'une action",
        fd: 'Services financiers',
        accessoirs: 'Equipement',
        accessoirsHeading: 'Sélectionner les équipements',
        searchText: 'Recherche plein texte',
        availabileDate: 'Date de disponibilité',
        asc: 'croissant',
        desc: 'descendant',
        Alle: 'Tous',
        alle: 'tous',
        from: 'à partir de',
        to: "jusqu'à",
        moreThan: 'plus que',
        vehicleClass: 'Type de véhicule',
        order: 'Ordre',
        ort: 'Emplacement',
        page: 'Page',
        pageSize: 'Nombre',
        sort: 'Trier',
        set: 'actif',
        setFilter: 'Filtre actif',
        ignoreStandort: 'Exclure le site',
        locExclude: "Exclure l'emplacement",
        locInclude: 'Emplacement',
        locSourceExclude: "Exclure l'emplacement (ID source)",
        locSourceInclude: 'Emplacement (ID source)',
        nfzHersteller: 'Fabricant VUL (Véhicule Utilitaire Léger)',
        nfz: 'VUL (Véhicule Utilitaire Léger)',
        lang: 'Langue',
        views: 'par défaut',
        takeinAsc: 'Les plus anciens en premier',
        takeinDesc: 'Les plus récents en premier',
    },
    footer: {
        co2DatLink: 'Guide CO₂',
        pshButton: 'Ouvrir les consignes de sécurité du produit du fabricant',
        textPsh:
            'Informations sur la sécurité du produit : Fabricant (((car.productSecurity.tradename))) | Adresse : (((car.productSecurity.firm)), (((car.productSecurity.address))) | Téléphone : (((car.productSecurity.phone)) | Mail : (((car.productSecurity.email))',
        textWLTP:
            "Les informations sont fournies conformément au règlement sur l'étiquetage de la consommation d'énergie des voitures. Les valeurs indiquées ont été déterminées selon la méthode de mesure prescrite WLTP (World Harmonised Light Vehicles Test Procedure). La consommation de carburant et les émissions de C02 d'une voiture ne dépendent pas uniquement de l'utilisation efficace du carburant par la voiture, mais également du style de conduite et d'autres facteurs non techniques. Le C02 est le principal gaz à effet de serre responsable du réchauffement climatique. Un guide sur la consommation de carburant et les émissions de C02 de tous les modèles de voitures particulières neuves proposées en Allemagne peut être consulté gratuitement sous forme électronique dans tous les points de vente en Allemagne où des voitures particulières neuves sont exposées ou proposées. Le guide peut également être consulté à l'adresse Internet suivante: {0}. Seules les émissions de C02 générées par l'utilisation de la voiture sont indiquées. Les émissions de C02 générées ou évitées par la production et la mise à disposition de la voiture particulière ainsi que du carburant ou des sources d'énergie ne sont pas prises en compte dans la détermination des émissions de C02 selon WLTP.",
    },
    menu: {
        activeConfig: 'Configuration active',
        currentVersion: 'Version actuelle',
        dark: 'Mode sombre',
        disabled: 'Désactivé',
        heading: 'Menu principal',
        light: 'Mode clair',
    },
    modules: {
        [Modules.Aktionsslider]: "Curseur d'action",
        [Modules.ConfigListing]: 'Configurations',
        [Modules.ErweiterteSchnellsuche]: 'RechercheRapideAvancé',
        [Modules.Fahrzeugliste]: 'Liste de véhicules',
        [Modules.Fahrzeugslider]: 'Curseur de véhicule',
        [Modules.Fahrzeugsuche]: 'Recherche de véhicule',
        [Modules.Finanzierungsansicht]: 'Vue Financement',
        [Modules.Install]: "Documentation d'installation",
        [Modules.Menu]: 'Menu',
        [Modules.Print]: 'Exposé',
        [Modules.Schnellsuche]: 'Recherche rapide',
        [Modules.Standorte]: 'Sites',
    },
    opening: {
        closed: 'fermé',
        openTill: "ouvert jusqu'à {0} heures",
        openAtToday: 'fermé, ouvre à {0} heures',
        openAtTomorrow: 'fermé, ouvre demain à {1} heures',
        openAtOtherDay: 'fermé, ouvre le {0} à {1} heures',
        verkauf: 'Vente',
        service: 'Service',
        werkstatt: 'Atelier',
    },
    time: {
        days: {
            '0': 'Dimanche',
            '1': 'Lundi',
            '2': 'Mardi',
            '3': 'Mercredi',
            '4': 'Jeudi',
            '5': 'Vendredi',
            '6': 'Samedi',
            singular: 'jour',
            plural: 'jours',
        },
        month: {
            plural: 'mois',
            singular: 'mois',
        },
        week: {
            plural: 'semaines',
            singular: 'semaine',
        },
        year: {
            plural: 'Années',
            singular: 'Année',
        },
    },
    validation: {
        invalid: 'Non valide!',
        invalidEntry: 'Valeur non valide! Autorisé: {0}',
        maxCarPrice: 'Le prix est plus élevé que celui du véhicule',
        minPrice: 'Prix trop bas',
        required: 'Champ obligatoire',
        wholeNumber: 'Seuls les entiers sont autorisés',
    },
};

export default frFR;
